import React from 'react'
import xCONS from 'x/config/constants'
import p from 'x/config/platform-specific'
import * as util from 'x/utils/util'
import {
  IApiOptions,
  IPackageDetails,
  IResponseGetSubscriptionsOrder,
  ISubscriptionPackageList,
  IXScreenProps,
  SubscriptionPackageListItems,
} from 'x/types'
import api from 'x/utils/api'
import * as NavActions from 'x/utils/navigation'
import _ from 'lodash'
import { COLORS } from 'x/config/styles'
import dayjs from 'dayjs'
import { isImmutable } from 'immutable'

interface IBaseSubscriptionViewProps extends IXScreenProps {
  profile: any
  subscription: any
  fetchSubscription: any
  hideSubscription: any
  hideQuotaWarning: any
  subscriptionWarning: {
    type: 'warning' | 'danger' | 'success'
    message: string
    closeable: boolean
    priority: number
  }
}

interface IBaseSubscriptionViewState {
  isInitialized?: boolean
  refreshing: boolean
  subscriptionPackageList: ISubscriptionPackageList
  packageDetails: IPackageDetails
  subscriptionPackangWaring: {
    bg: string
    ms: string
  }
  subscriptionOrderWaring: {
    bg: string
    ms: string
  }
  subscriptionAllQuotaWaring: {
    bg: string
    ms: string
  }
  pendingOrderData: IResponseGetSubscriptionsOrder

  isLoadingCancelSubscription: boolean
}

const warningActionPackage = 'กรุณาติดต่อทีมงาน LINE: @XSelly หรือ โทร 097-167-1650'

export default abstract class BaseSubscriptionView extends React.Component<IBaseSubscriptionViewProps, IBaseSubscriptionViewState> {
  // abstract async handleSubmitForm(response: any): Promise<void>
  // abstract didMountCheckPermissionForPhone?: () => void
  // validationSchema: Yup.ObjectSchema<any>
  // imgManagerIDRef: React.RefObject<any>
  // webview: React.RefObject<any>
  mainPackageItems: any

  inLoopPamyntChackProcess: boolean

  isViewMounted: boolean

  constructor(props) {
    super(props)
    // @ts-ignore
    this.state = {
      refreshing: false,
      packageDetails: null,
      subscriptionPackangWaring: null,
      subscriptionOrderWaring: null,
      subscriptionAllQuotaWaring: null,
      pendingOrderData: null,
      isInitialized: false,
      isLoadingCancelSubscription: false,
    }
    // this.webview = React.createRef()
    // this.imgManagerIDRef = React.createRef()
    // @ts-ignore
    // eslint-disable-next-line react/no-unused-class-component-methods
    this.mainPackageItems = xCONS.SUBSCRIPTION_MAIN_PACKAGE_ITEMS.map((item) => ({
      ...item,
      label: p.op.t(`Subscription.main.${item.key}`),
    }))
    this.inLoopPamyntChackProcess = false
    this.isViewMounted = false
  }

  async componentDidMount() {
    this.isViewMounted = true
    await util.delay(100)
    await this._fetchSubscriptionPackageList()
    await util.delay(100)

    // console.log('componentDidMount 02 => ')
    // await this._getPackageDetails()
    // console.log('componentDidMount 01 => ')
    const { profile, subscription, fetchSubscription } = this.props
    // console.log(';subscription => ', subscription.toJS())
    // util.checkSubscriptionAllQuota(subscription.toJS())
    if (!profile || !profile.get('user_id')) {
      this._onRefresh()
    } else if (profile && profile.get('user_id') && (!subscription || !subscription.get('user_id'))) {
      fetchSubscription()
    }
    await this._getSubscriptionOrder()
    this._setSubscriptionPackangWarning()
    this._setSubscriptionOrderWarning()
    this._setSubscriptionAllQuotaWarning()
    await util.delay(100)
    await util.setStatePromise(this, { isInitialized: true })
    const params = this._getParams()
    const { isHideSubscriptionWarning, addOnDubledNavKey } = params
    // console.log('BaseSubscriptionView isHideSubscriptionWarning => ', isHideSubscriptionWarning)
    if (!_.isNil(isHideSubscriptionWarning) && isHideSubscriptionWarning) {
      this.props.hideSubscription()
      this.props.hideQuotaWarning()
    }

    if (!_.isNil(addOnDubledNavKey)) {
      // console.log('BaseSubscriptionView addOnDubledNavKey => ', addOnDubledNavKey)
      if (addOnDubledNavKey === 'buy_package' || addOnDubledNavKey === 'upgrade') {
        this._navToInAppPurchaseView(addOnDubledNavKey)
      } else if (addOnDubledNavKey === 'continue_package') {
        this._navToSelectedSubscriptionPackageView(addOnDubledNavKey)
      } else {
        this._navToBuyAddOnPackage(addOnDubledNavKey)
      }
    }
    // console.log('BaseSubscriptionView componentDidMount => ', this.props.subscription.toJS())
    this.isViewMounted = false
  }

  componentWillUnmount() {
    this.isViewMounted = false
    this.inLoopPamyntChackProcess = false
  }

  _getParams = () => {
    // @ts-ignore
    const params = util.getNavParams(this.props)
    return params
  }

  // _getPackageDetails = async () => {
  //   await util.setStatePromise(this, {
  //     packageDetails: JSON_PACKAGE_DETAIL_DATA,
  //   })
  // }

  // unUes
  // shouldComponentUpdate(nextProps, nextState) {
  //   console.log('shouldComponentUpdate 00 => ', nextProps)
  //   console.log('shouldComponentUpdate 01 => ', nextState)
  //   const isStateDiff = util.isDiff(this.props, nextProps, ['profile', 'subscription'])
  //   const isPropsDiff = util.isDiff(this.state, nextState, ['refreshing'])
  //   return isStateDiff || isPropsDiff
  // }

  _fetchNewSubscription = async () => {
    const { fetchSubscription } = this.props
    await fetchSubscription({
      successCallback: (newSub) => this._initNewSubscription(newSub),
      failedCallback: null,
    })
  }

  _initNewSubscription = async (newSubscription) => {
    // console.log('_initNewSubscription newSubscription => ', newSubscription)
    this._setSubscriptionPackangWarning(newSubscription)
    this._setSubscriptionOrderWarning(newSubscription)
    this._setSubscriptionAllQuotaWarning(newSubscription)
    this.isViewMounted = false
    await util.setStatePromise(this, {
      refreshing: false,
    })
  }

  _getSubscriptionOrder = async () => {
    if (!this.isViewMounted) {
      return
    }
    const reqBody = {
      is_pending: true,
    }
    const apiOptions: IApiOptions = {
      showSpinner: true,
    }
    const res = await api.postV2(api.POST_ORDER_SUBSCRIPTION_GET, reqBody, apiOptions)
    // console.log('_getSubscriptionOrder res => ', res)
    if (res?.id) {
      await util.setStatePromise(this, { pendingOrderData: res })
      if (res.status === 'pending') {
        // await util.delay(5000)
        this.inLoopPamyntChackProcess = true
        this._loopChackPayment()
      }
      // this.props.fetchSubscription()
      await this._fetchNewSubscription()
    } else {
      // this.props.fetchSubscription()
      await util.setStatePromise(this, { pendingOrderData: null })
      await this._fetchNewSubscription()
    }
    this.isViewMounted = false
  }

  _fetchSubscriptionPackageList = async () => {
    if (!this.isViewMounted) {
      return
    }
    const { subscription } = this.props
    const res = await util.fetchSubscriptionPackageList(subscription)
    // this.isViewMounted = false
    await util.setStatePromise(this, {
      subscriptionPackageList: res,
    })
  }

  _setSubscriptionPackangWarning = (newSubscription = null) => {
    const { subscription } = this.props
    const lastSubscription = _.isNil(newSubscription) ? subscription : newSubscription
    // console.log('subscription // => ', subscription.toJS())
    const subscriptionPackangWaring = util.getPackageWraning(lastSubscription)
    // console.log('subscriptionPackangWaring => ', subscriptionPackangWaring)
    // eslint-disable-next-line react/no-unused-state
    this.setState({ subscriptionPackangWaring })
  }

  _setSubscriptionOrderWarning = (newSubscription = null) => {
    const { subscription } = this.props
    // const showBtnPerPackage = util.isDevMode()
    // if (!showBtnPerPackage || _.isNil(subscription)) {
    //   return
    // }
    const lastSubscription = _.isNil(newSubscription) ? subscription : newSubscription
    if (_.isNil(lastSubscription)) {
      return
    }
    const subscriptionJs = isImmutable(lastSubscription) ? lastSubscription.toJS() : lastSubscription
    // console.log('subscriptionJs => ', subscriptionJs)
    // order_count_quota_exceeded_at
    const { order_count_curr, order_count_quota, is_new_subscription, order_count_quota_exceeded_at, end_billing_date, endBillingDate } =
      subscriptionJs
    // console.log('order_count_quota_exceeded_at => ', order_count_quota_exceeded_at)
    if (_.isNil(is_new_subscription)) {
      // eslint-disable-next-line react/no-unused-state
      this.setState({ subscriptionOrderWaring: null })
      return
    }
    const availableOrder = order_count_quota - order_count_curr
    // console.log('availableOrder => ', availableOrder)
    const availableOrderPercent = Math.round((availableOrder / order_count_quota) * 100)
    let message = `คุณใช้ออเดอร์เกินจำนวนโควตา คุณสามารถเลือกอัพเกรดแพ็กเกจของคุณ หรือ ซื้อแพ็กเกจเสริมเพิ่มออเดอร์ เพื่อที่จะสามารถใช้งานได้ต่อไป`
    let bg = COLORS.BRAND_Warning
    if (availableOrderPercent > 20) {
      // eslint-disable-next-line react/no-unused-state
      this.setState({ subscriptionOrderWaring: null })
      return
    }
    const endBillingDateTime = !_.isNil(end_billing_date) ? dayjs(end_billing_date) : dayjs(endBillingDate)
    if (availableOrderPercent <= 20 && availableOrderPercent > 0) {
      // start_billing_date.endDate.clone().fromNow()
      message = `รอบบิลนี้เหลืออีก ${dayjs(endBillingDateTime)
        .clone()
        .fromNow()} โดย คุณเหลือโควตาสำหรับใช้งานออเดอร์อีก ${availableOrder}  ออเดอร์ คุณสามารถเลือกอัพเกรดแพ็กเกจของคุณ หรือ ซื้อแพ็กเกจเสริมเพิ่มออเดอร์ เพื่อที่จะสามารถใช้งานได้อย่างต่อเนื่อง`
    }

    if (!_.isNil(order_count_quota_exceeded_at)) {
      const exceeded_at_moment = dayjs(order_count_quota_exceeded_at)
      const addOneDay = exceeded_at_moment.clone().add(1, 'd').format('YYYY-MM-DD 23:59:59')
      // console.log('addOneDay ! ', addOneDay)
      const diffTime = dayjs().diff(dayjs(addOneDay), 'm')
      message = `คุณจะไม่สามารถเปิดออเดอร์ได้อีก หลังจาก ${dayjs(addOneDay)
        .clone()
        .format(
          'D MMM YYYY 23:59'
        )} เนื่องจากคุณใช้งาน **ออเดอร์** เกินโควตา (ใช้อยู่ ${order_count_curr} จาก ${order_count_quota}) กรุณา อัพเกรดแพ็กเกจ หรือ ซื้อแพ็กเสริม`
      bg = diffTime >= 0 ? COLORS.BRAND_Danger : COLORS.BRAND_Warning
    }

    const subscriptionNewOrderWaring = {
      bg,
      ms: message,
    }

    // eslint-disable-next-line react/no-unused-state
    this.setState({ subscriptionOrderWaring: subscriptionNewOrderWaring })
  }

  _setSubscriptionAllQuotaWarning = (newSubscription = null) => {
    const { subscription } = this.props
    const lastSubscription = _.isNil(newSubscription) ? subscription : newSubscription
    // const showBtnPerPackage = util.isDevMode()
    const showBtnPerPackage = true
    if (!showBtnPerPackage || _.isNil(lastSubscription)) {
      return
    }
    const subscriptionJs = isImmutable(lastSubscription) ? lastSubscription.toJS() : lastSubscription
    const { is_new_subscription } = subscriptionJs
    if (_.isNil(is_new_subscription)) {
      return
    }
    const getWarning = util.checkSubscriptionAllQuota(subscriptionJs, true)
    if (_.isNil(getWarning)) {
      return
    }
    const subscriptionAllQuotaWaring = {
      bg: getWarning.type === 'warning' ? COLORS.BRAND_Warning : COLORS.BRAND_Danger,
      ms: getWarning.message,
    }
    // eslint-disable-next-line react/no-unused-state
    this.setState({ subscriptionAllQuotaWaring })
  }

  // eslint-disable-next-line react/no-unused-class-component-methods
  _hideObject = () => {
    const { subscription } = this.props
    const orderCount = subscription.get('order_count_curr') || 0
    const isIOS = p.op.isIOS()
    // console.log('/// => ', orderCount < 11 && subscription.get('type') === xCONS.SUBSCRIPTION_PACKAGE.FREE)
    return isIOS && orderCount < 3 && subscription.get('type') === xCONS.SUBSCRIPTION_PACKAGE.FREE
  }

  _onRefresh = () => {
    // console.log('fetchSubscription err 00 => ', this.isViewMounted)
    if (!this.isViewMounted) {
      return
    }
    this.setState({ refreshing: true })
    this._getSubscriptionOrder()
  }

  // _callbackFormSlectedMainPackage = (itam: SubscriptionPackageListItems) => {
  //   console.log('_callbackFormSlectedMainPackage => ', itam)
  // }

  // _navToSelectMainPackageView = (mode: 'NEW_PACKAGE' | 'UPGRADE_PACKAGE' | 'PER_PACKAGE') => {
  //   const { subscriptionPackageList } = this.state
  //   // @ts-ignore
  //   const { navigation } = this.props
  //   navigation.dispatch(
  //     NavActions.navToSelectMainPackageView({
  //       subscriptionPackageList,
  //       mode,
  //       callback: (itam: SubscriptionPackageListItems) => this._callbackFormSlectedMainPackage(itam),
  //     })
  //   )
  // }

  _navToPaymentSubscriptionPackageView = () => {
    const { navigation } = this.props
    navigation.dispatch(NavActions.navToPaymentSubscriptionPackageView({}))
  }

  _navToInAppPurchaseView = (mode: 'buy_package' | 'continue_package' | 'upgrade' | 'add_on') => {
    const { subscriptionPackageList } = this.state
    const { navigation } = this.props
    navigation.dispatch(
      NavActions.navToInAppPurchaseView({
        subscriptionPackageList,
        mode,
        callBackSucceedPaymentIos: () => this.callBackSucceedPaymentIos(),
        succeedPaymentCallBack: () => {
          this.isViewMounted = true
          this._getSubscriptionOrder()
        },
      })
    )
  }

  _getMaimPackageByAddonMode = () => {
    const { subscription } = this.props
    const { subscriptionPackageList } = this.state
    const { type, current_package_billing_cycle } = subscription.toJS()
    let mainPackage = null
    const { items } = subscriptionPackageList
    if (!_.isNil(current_package_billing_cycle) && current_package_billing_cycle.length > 0) {
      const upgradePackageList = current_package_billing_cycle.filter((item) => item.item_type === 'package_upgrade')
      if (upgradePackageList.length > 0) {
        // @ts-ignore
        // upgradePackageList.sort((a, b) => new Date(a.end_date) - new Date(b.end_date))
        // console.log('upgradePackageList * => ', upgradePackageList)
        const lengthPackage = upgradePackageList.length
        const upgradePackageSku = upgradePackageList[lengthPackage - 1].sku
        mainPackage = util.changePackageUpgradeSkuToNormalSku(upgradePackageSku)
      } else {
        current_package_billing_cycle.forEach((item) => {
          if (item.item_type === 'package_main') {
            mainPackage = item.sku
          }
        })
      }
    } else {
      const typeName = util.getSubscriptionTypeName(type)
      items.forEach((item) => {
        if (item.item_subtype === typeName && item.billing_cycle === 12) {
          mainPackage = item.sku
        }
      })
    }
    return mainPackage
  }

  _navToSelectedSubscriptionPackageView = (
    mode: 'upgrade' | 'continue_package' | 'buy_package' | 'add_on' | 'pending',
    navToPayment = false
  ) => {
    const { subscriptionPackageList, pendingOrderData } = this.state
    // console.log('pendingOrderData => ', pendingOrderData)
    const { navigation } = this.props
    const packagePanding = _.has(pendingOrderData, 'items') ? pendingOrderData.items : null
    let mainPackage = null
    if (!_.isNil(packagePanding)) {
      packagePanding.forEach((item) => {
        if (_.includes(xCONS.SUBSCRIPTION_MAIN_PACKAGE_SKU, item.sku)) {
          mainPackage = item.sku
        }
      })
    }

    if (!util.isXsellier(this.props.subscription)) {
      p.op.showConfirmationOkOnly('', 'กรุณาติดต่อทีมงานที่ LINE: @XSelly หรือ โทร 097-167-1650')
      return
    }

    // let mode = 'continue_package'
    // หากเป็นการซื้อแพ็กเสริมจะไม่มีข้อมูลแพ็กหลัก  ให้ไปหยิบแพ็กปัจจุบันมาใช้
    if (_.isNil(mainPackage)) {
      mainPackage = this._getMaimPackageByAddonMode()
      // mode = 'add_on'
    }
    // console.log('mainPackage => ', mainPackage)
    // console.log('mode => ', mode)
    this.inLoopPamyntChackProcess = false
    navigation.dispatch(
      NavActions.navToSelectedSubscriptionPackageView({
        subscriptionPackageList,
        sku: mainPackage,
        succeedPaymentCallBack: () => {
          this.isViewMounted = true
          this._getSubscriptionOrder()
        },
        mode,
        navToPayment,
      })
    )
  }

  callBackSucceedPaymentIos = () => {
    this._onRefresh()
    p.op.storageClear(xCONS.STORAGE_KEYS.SUBSCRIPTION_PACKAGE_TRACKER)
    if (_.isFunction(this.props.hideSubscription)) {
      this.props.hideSubscription()
    }
  }

  _navToInAppPurchasePerPackageView = () => {
    const { navigation, subscription } = this.props
    const { subscriptionPackageList } = this.state
    const canPerPackage = util.PerPackageCheck(subscriptionPackageList)
    // console.log('canPerPackage => ', canPerPackage)
    this.props.hideSubscription()
    this.props.hideQuotaWarning()
    if (!canPerPackage) {
      return
    }
    // this._navToSelectedSubscriptionPackageView('continue_package')
    // return
    const IS_XSELLIER = util.isXsellier(subscription)
    if (IS_XSELLIER) {
      // this._navToInAppPurchaseView('continue_package')
      this._navToSelectedSubscriptionPackageView('continue_package')
      return
    }
    if (p.op.isIOS()) {
      navigation.dispatch(
        NavActions.navToInAppPurchasePerPackageView({
          subscriptionPackageList,
          callBackSucceedPaymentIos: () => this.callBackSucceedPaymentIos(),
        })
      )
    }
    // this._navToInAppPurchaseView('continue_package')
  }

  _navToBuyAddOnPackage = (addOnDubledNavKey?: string) => {
    const { subscriptionPackageList, pendingOrderData } = this.state
    const { navigation, subscription } = this.props
    const packagePanding = _.has(pendingOrderData, 'items') ? pendingOrderData.items : null
    let mainPackage = null
    if (!_.isNil(packagePanding)) {
      return p.op.showConfirmationOkOnly('', 'คุณมีแพ็กเกจที่รอการตรวจสอบอยู่  กรุณาลองใหม่ภายหลัง')
    }
    // if (mainPackage === '') {
    //   return p.op.showConfirmationOkOnly('', warningActionPackage)
    // }
    this.inLoopPamyntChackProcess = false
    // console.log('subscription \\ => ', subscription.toJS())
    const { type, current_package_billing_cycle, order_count_quota, order_count_curr } = subscription.toJS()
    // console.log('current_package_billing_cycle => ', current_package_billing_cycle)
    const { items } = subscriptionPackageList
    if (!_.isNil(current_package_billing_cycle) && current_package_billing_cycle.length > 0) {
      const upgradePackageList = current_package_billing_cycle.filter((item) => item.item_type === 'package_upgrade')
      if (upgradePackageList.length > 0) {
        // @ts-ignore
        // upgradePackageList.sort((a, b) => new Date(a.end_date) - new Date(b.end_date))
        // console.log('upgradePackageList * => ', upgradePackageList)
        const lengthPackage = upgradePackageList.length
        const upgradePackageSku = upgradePackageList[lengthPackage - 1].sku
        mainPackage = util.changePackageUpgradeSkuToNormalSku(upgradePackageSku)
      } else {
        current_package_billing_cycle.forEach((item) => {
          if (item.item_type === 'package_main') {
            mainPackage = item.sku
          }
        })
      }
    } else {
      const typeName = util.getSubscriptionTypeName(type)
      items.forEach((item) => {
        if (item.item_subtype === typeName && item.billing_cycle === 12) {
          mainPackage = item.sku
        }
      })
    }
    // console.log('mainPackage // => ', mainPackage)
    const isXsellier = util.isXsellier(subscription)
    if (isXsellier) {
      const orderCountQuota = order_count_quota || 0
      const orderCountCurr = order_count_curr || 0
      const availableOrder = orderCountQuota - orderCountCurr
      const availableOrderPercent = Math.round((availableOrder / order_count_quota) * 100)

      let addOnNavKey = _.isNil(order_count_quota) || availableOrderPercent > 20 ? null : 'order_count_quota'
      if (!_.isNil(addOnDubledNavKey)) {
        addOnNavKey = addOnDubledNavKey
      }

      navigation.dispatch(
        NavActions.navToSelectedSubscriptionPackageView({
          subscriptionPackageList,
          sku: mainPackage,
          succeedPaymentCallBack: () => {
            this.isViewMounted = true
            this._getSubscriptionOrder()
          },
          mode: 'add_on',
          addOnDubledNav: addOnNavKey,
        })
      )
    } else {
      p.op.showConfirmationOkOnly('', warningActionPackage)
    }
  }

  _navToUpgradePackage = () => {
    p.op.showConfirmationOkOnly('', warningActionPackage)
  }

  // _navToBuyAddOnPackage = () => {
  //   p.op.showConfirmationOkOnly('', warningActionPackage)
  // }

  _navToActivePackageDetailView = () => {
    const { subscriptionPackageList } = this.state
    const { navigation } = this.props
    navigation.dispatch(
      NavActions.navToActivePackageDetailView({
        subscriptionPackageList,
        callBackSucceedPaymentIos: () => this.callBackSucceedPaymentIos(),
      })
    )
  }

  _navToNextPackageDetailView = () => {
    const { subscriptionPackageList } = this.state
    const { navigation } = this.props
    navigation.dispatch(
      NavActions.navToNextPackageDetailView({
        subscriptionPackageList,
        callBackSucceedPaymentIos: () => this.callBackSucceedPaymentIos(),
      })
    )
  }

  _getCountPackageByKey = (key: string) => {
    const { subscription } = this.props
    if (_.isNil(subscription)) {
      return '-'
    }
    const subscriptionJS = subscription.toJS()
    return subscriptionJS[key]
  }

  _canRenderBuyPackage = () => {
    let isCanRenderBuyPack = false
    if (p.op.isIOS()) {
      isCanRenderBuyPack = true
    }
    return isCanRenderBuyPack
  }

  _canRenderPerPackage = () => {
    let isCanRenderBuyPack = true
    // if (p.op.isIOS()) {
    //   isCanRenderBuyPack = true
    // }
    const { subscription } = this.props
    const subscriptionJS = isImmutable(subscription) ? subscription.toJS() : subscription
    if (_.has(subscriptionJS, 'next_package_billing_cycle')) {
      isCanRenderBuyPack = false
    }
    if (subscriptionJS.type === xCONS.SUBSCRIPTION_PACKAGE.TRIAL) {
      isCanRenderBuyPack = false
    }
    return isCanRenderBuyPack
  }

  _getCurentPackage = (
    currentPackage: {
      billing_cycle: number
      data_json: any
      start_date: string
      end_date: string
      item_type: string
      qty: number
      sku: number
    }[]
  ) => {
    if (_.isNil(currentPackage)) {
      return null
    }
    let packageMain = null
    currentPackage.forEach((packageData) => {
      if (packageData.item_type === 'package_main') {
        packageMain = packageData
      }
    })
    return packageMain
  }

  _showBtnPerPackage = () => {
    const { subscription } = this.props
    return subscription.get('is_package_main_extendable')
    // const AVAILABLE_TYPES = [2, 3, 4, 5]
    // if (_.isNil(subscription) || !_.includes(AVAILABLE_TYPES, subscription.get('type'))) {
    //   return false
    // }

    // const subscriptionJS = isImmutable(subscription) ? subscription.toJS() : subscription
    // if (_.has(subscriptionJS, 'next_package_billing_cycle')) {
    //   return false
    // }

    // return true
  }

  _showUpgradePackage = () => {
    // const end = dayjs(util.getSubcriptionEndDate(this.props.subscription)) // อายุการใช้งานวันสุดท้ายของแพ็กเกจ
    // const toDay = dayjs(new Date())
    // const timeLeft = end.clone().diff(toDay.clone(), 'd')
    // const type = this.props.subscription.get('type')
    // // console.log('timeLeft => ', timeLeft)
    // return timeLeft > 0 && type !== 5 && util.isXsellier(this.props.subscription)
    const { subscription } = this.props

    return subscription.get('is_package_main_upgradable') && util.isXsellier(this.props.subscription)
  }

  _showAddonBtn = () => {
    const { subscription } = this.props
    const { pendingOrderData } = this.state
    // console.log('timeLeft => ', timeLeft)
    const is_addon_purchasable = subscription.has('is_addon_purchasable') ? subscription.get('is_addon_purchasable') : false
    return _.isNil(pendingOrderData) && util.isXsellier(subscription) && is_addon_purchasable
  }

  _cancelPendingOrder = async () => {
    const profileProps = this.props.profile
    const { pendingOrderData } = this.state
    const profile = isImmutable(profileProps) ? profileProps.toJS() : profileProps
    const { id } = pendingOrderData
    const isUserConfirmed = await new Promise<boolean>((passConfirm) => {
      p.op.showConfirmation(
        `ยกเลิกคำสั่งซื้อ #${id}`,
        `ต้องการยกเลิกคำสั่งซื้อ #${id} หรือไม่`,
        () => passConfirm(true),
        () => passConfirm(false)
      )
    })
    if (!isUserConfirmed) return
    await util.setStatePromise(this, { isLoadingCancelSubscription: true })
    const reqBody = {
      user_id: profile.user_id,
    }
    const apiOptions: IApiOptions = {
      showSpinner: true,
    }
    const res = await api.postV2('xselly/order/cancel', reqBody, apiOptions)
    // console.log('res cancel => ', res)
    if (res?.id) {
      this._onRefresh()
      p.op.showToast('ยกเลิกคำสั่งซื้อเรียบร้อย', 'success')
      await util.setStatePromise(this, { isLoadingCancelSubscription: false })
    }
  }

  _loopChackPayment = async () => {
    const { pendingOrderData } = this.state
    if (_.isNil(pendingOrderData)) {
      return
    }
    const reqBody = {
      order_id: pendingOrderData.id,
    }
    const res: IResponseGetSubscriptionsOrder = await api.postV2(api.POST_ORDER_SUBSCRIPTION_GET, reqBody)
    // console.log('_loopChackPayment res => ', res)
    if (res?.status === 'completed') {
      this.inLoopPamyntChackProcess = false
      await util.setStatePromise(this, { pendingOrderData: null })
      await this._fetchNewSubscription()
      return
    }

    if (res.status === 'cancelled') {
      this.inLoopPamyntChackProcess = false
      await util.setStatePromise(this, { pendingOrderData: null })
      await this._fetchNewSubscription()
    }

    await util.delay(5000)
    if (this.inLoopPamyntChackProcess) {
      await this._loopChackPayment()
    }
  }
}
